import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const saveTenderDraft = createAsyncThunk(
    "tender/saveTenderDraft",
    async (form, { rejectWithValue, getState }) => {
        try {

            const { selectedVendors } = getState().internalTender;

            const fd = new FormData();

            fd.append("title", form.title);
            fd.append("description", form.description);
            fd.append("budget", form.budget);
            fd.append("deadline", form.deadline);

            fd.append("category_id", form.categoryId);
            fd.append("jenis_id", form.jenisId);

            if (form.ursFile) {
                fd.append("urs_file", form.ursFile);
            }

            /*
            |--------------------------------------------------------------------------
            | Vendor yang dipilih
            |--------------------------------------------------------------------------
            */

            selectedVendors.forEach((vendor) => {
                fd.append("vendors[]", vendor.id);
            });
            

            const res = await axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}/tenders`,
                fd,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            return res.data;

        } catch (err) {

            const payload = {
                status: err?.response?.status,
                message:
                    err?.response?.data?.message ||
                    "Terjadi kesalahan",
                errors:
                    err?.response?.data?.errors ||
                    null,
            };

            return rejectWithValue(payload);
        }
    }
);

export const getTenderList = createAsyncThunk(
    "tender/getTenderList",
    async (_, thunkAPI) => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/tenders`
            );

            //console.log("API", res.data);

            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data || {
                    message: "Gagal mengambil data tender",
                }
            );
        }
    }
);

const tenderFmSlice = createSlice({
    name: "tender",

    initialState: {
        loading: false,
        list: [],
        error: null,
        success: false,
        data: null,
    },

    reducers: {
        resetTenderState: (state) => {
            state.loading = false;
            state.error = null;
            state.success = false;
            state.data = null;
        },
    },

    extraReducers: (builder) => {
        builder

            .addCase(
                saveTenderDraft.pending,
                (state) => {
                    state.loading = true;
                    state.error = null;
                }
            )

            .addCase(
                saveTenderDraft.fulfilled,
                (state, action) => {
                    state.loading = false;
                    state.success = true;
                    state.data = action.payload;
                }
            )

            .addCase(
                saveTenderDraft.rejected,
                (state, action) => {
                    state.loading = false;
                    state.error = action.payload;
                }
            )

            .addCase(getTenderList.pending, (state) => {
                state.loading = true;
            })

            .addCase(getTenderList.fulfilled, (state, action) => {
                console.log("FULFILLED", action.payload);
                state.loading = false;
                state.success = true;
                state.list = action.payload.data || [];
            })

            .addCase(
                getTenderList.rejected,
                (state) => {
                    state.loading = false;
                }
            );
    },
});

export const {
    resetTenderState,
} = tenderFmSlice.actions;

export default tenderFmSlice.reducer;